module.exports = __webpack_public_path__ + "assets/img/34_705_big.7ad89d83.jpg";